define('frontend-common-components/objectStorageConfig/js/helpers/handlebars/i18n',[
        'hbs',
        'i18n!../../../nls/objectStorageConfig',
        '../../../../utils/i18nMessageLoader'
    ],
    function (hbs, messageBundle, i18nMessageLoader) {
        'use strict';


        var i18nHelper = i18nMessageLoader(messageBundle);

        hbs.get().registerHelper('i18n-objectStorageConfig', i18nHelper);

        return i18nHelper;
    });
